import React, { useState, useEffect } from 'react';
import API from '../services/api';

const trTutar = v => (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 });

const KARTKOD_AD = { 4: 'Nakit Kasa', 5: 'POS / Banka', 6: 'Banka Hesabı' };
const KARTKOD_RENK = {
  4: { bg:'#e7f5ee', fg:'#1a7a45' },
  5: { bg:'#e7f0ff', fg:'#2563c9' },
  6: { bg:'#fff0e6', fg:'#c2570a' },
};

export default function Kasa() {
  const [data, setData] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    API.get('/Finans/kasa')
      .then(r => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setYukleniyor(false));
  }, []);

  const gruplar = data ? [4, 5, 6].reduce((acc, kod) => {
    const satirlar = (data.liste || []).filter(x => x.kartKod === kod);
    if (satirlar.length) acc.push({ kod, satirlar });
    return acc;
  }, []) : [];

  return (
    <div>
      <h1 className="sayfa-baslik">Kasa Durumu</h1>
      <p className="sayfa-alt">Anlık kasa ve banka bakiyeleri.</p>

      {yukleniyor && <div className="kart kart-pad">Yükleniyor…</div>}

      {!yukleniyor && data && (
        <>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:18 }}>
            <span className="bilgi-rozet" style={{ fontWeight:700, fontSize:15 }}>
              💼 Genel Toplam: {trTutar(data.toplam)} ₺
            </span>
          </div>

          {gruplar.map(({ kod, satirlar }) => {
            const renk = KARTKOD_RENK[kod] || { bg:'#eef0f4', fg:'#6b7280' };
            const grupToplam = satirlar.reduce((s, x) => s + (x.bakiye || 0), 0);
            return (
              <div key={kod} className="kart" style={{ overflow:'hidden', marginBottom:16 }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center',
                              background:renk.bg, color:renk.fg, padding:'10px 16px', fontWeight:700, fontSize:14 }}>
                  <span>{KARTKOD_AD[kod] || 'Diğer'}</span>
                  <span>{trTutar(grupToplam)} ₺</span>
                </div>
                <table className="tablo">
                  <tbody>
                    {satirlar.map((r, i) => (
                      <tr key={i}>
                        <td style={{ fontWeight:600 }}>{r.hesap || '—'}</td>
                        <td style={{ textAlign:'right', fontWeight:700, color: r.bakiye < 0 ? '#c0392b' : renk.fg }}>
                          {trTutar(r.bakiye)} ₺
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })}

          {gruplar.length === 0 && <div className="kart kart-pad bos-durum">Kasa kaydı bulunamadı.</div>}
        </>
      )}
    </div>
  );
}
